import { allowedPlanTypes } from '../constants/plans';

export default async function ({ store, route, params, redirect }) {
  const needsLoad = !store.getters['plan/isLoaded'];

  if (needsLoad) {
    await store.dispatch('plan/refreshPlan', { plan_uuid: params.id });
  }

  const planType = store.getters['plan/getPlanType'];
  const routeName = route.name;

  if (!planType || !routeName) return;

  const allowedTypes = allowedPlanTypes[routeName];

  if (allowedTypes && !allowedTypes.includes(planType)) {
    return redirect(`/plans/${params.id}`);
  }
}
